var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items.length)?_c('div',{staticClass:"public-gallery",on:{"click":_vm.handleFullScreenImage}},[_c('lingallery',{attrs:{"mobile-height":400,"mobile-height-breakpoint":3000,"addons":{ enableLargeView: true, enablePictureElement: true },"items":_vm.images,"responsive":true,"showThumbnails":_vm.images.length > 1}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }